/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import LpDivorceMeta from "./LpDivorceMeta";
import Container from "@/src/components/Container/Container";
import DivorceCheckin from "@/src/components/Checkin/DivorceCheckin/DivorceCheckin";
import { landingPagesList } from "@/src/services/landingPagesList";
import { getLastPathSplit } from "@/src/services/redirect";
import TeamSection from "@/src/components/Sections/Generic/TeamSection/TeamSection";
import LayoutPublicRoutes from "@/src/containers/Layouts/LayoutPublicRoutes";
import KindsOfDivorceSection from "@/src/components/Sections/Divorce/KindsOfDivorceSection/KindsOfDivorceSection";
import AdvantagesLegalbirdAttorneySection from "@/src/components/Sections/Generic/AdvantagesLegalbirdAttorneySection/AdvantagesLegalbirdAttorneySection";
import ProcedureDivorceSection from "@/src/components/Sections/Divorce/ProcedureDivorceSection/ProcedureDivorceSection";
import BirdMapSection from "@/src/components/Sections/Divorce/BirdMapSection/BirdMapSection";
import DivorcePlannerSection from "@/src/components/Sections/Divorce/DivorcePlannerSection/DivorcePlannerSection";
import CustomerFeedback from "@/src/components/Sections/Generic/CustomerFeedback/CustomerFeedback";
import LandingPageTeaser from "@/src/components/Teaser/LandingPageTeaser";
import ServiceSection from "@/src/components/Sections/Generic/ServiceSection/ServiceSection";
import PartnersSection from "@/src/components/Sections/Generic/PartnersSection/PartnersSection";
import { divorceTeaserCards } from "@/src/services/landingPageService";
import LinkedCardBox from "@/src/components/LinkedCardBox/LinkedCardBox";
import { useLocation } from "react-router";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import OurService from "@/src/components/Sections/Generic/OurService/OurService";

const LpDivorce = () => {
  const location = useLocation();
  const lpKey = getLastPathSplit(location.pathname);
  const keyword = (lpKey && landingPagesList[lpKey]?.keyword) ?? "Scheidung";
  const headline = (lpKey && landingPagesList[lpKey]?.headline) ?? "Scheidung online - im Guten trennen und Geld sparen";
  const { isLoggedIn } = useCustomer();

  return (
    <LayoutPublicRoutes minimal={!isLoggedIn} clickableLogo={isLoggedIn}>
      <LpDivorceMeta keyword={keyword} />
      <LandingPageTeaser
        headline={headline}
        subheadline={"Wir begleiten Sie sicher bei Ihrer Scheidung."}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={divorceTeaserCards} />
      </LandingPageTeaser>
      {!isLoggedIn && (
        <Container>
          <DivorceCheckin idPrefix={"top"} checkinHeading={"Wir führen Sie Schritt für Schritt durch Ihre Scheidung"} />
        </Container>
      )}
      <KindsOfDivorceSection />
      <ServiceSection product={"divorce"} />
      <TeamSection isSubsection={true} />
      <BirdMapSection />
      <AdvantagesLegalbirdAttorneySection />
      <OurService />
      <DivorcePlannerSection />
      <ProcedureDivorceSection />
      <CustomerFeedback />
      {!isLoggedIn && (
        <Container>
          <DivorceCheckin idPrefix={"bottom"} checkinHeading={"Wir führen Sie Schritt für Schritt durch Ihre Scheidung"} />
        </Container>
      )}
      <PartnersSection />
    </LayoutPublicRoutes>
  );
};

export default LpDivorce;
